import ReBuildType from "../index";

export const reBuildTypeConstants = {
	GetBuildTypes: {
		REQUEST : 'GET_NRI_BUILD_TYPES_REQUEST',
		SUCCESS : 'GET_NRI_BUILD_TYPES_SUCCESS',
		FAILURE : 'GET_NRI_BUILD_TYPES_FAILURE'
	},
	ClearBuildTypes: 'CLEAR_NRI_BUILD_TYPES'
}